export const USER_DISMISSED_PRIVACY_NOTICE = 'USER_DISMISSED_PRIVACY_NOTICE';
export const USER_IS_POLICY_RESIDENT = 'USER_IS_POLICY_RESIDENT';
export const USER_HAS_OPTED_OUT = 'USER_HAS_OPTED_OUT';

export function dismissPrivacyNotice(dismissed) {
    return {
        type: USER_DISMISSED_PRIVACY_NOTICE,
        payload: {
            userDismissedPrivacyNotice: dismissed
        }
    };
}

export function setPolicyResidency() {
    return {
        type: USER_IS_POLICY_RESIDENT,
        payload: {
            userIsResident: true
        }
    };
}

export function optOutUser() {
    return {
        type: USER_HAS_OPTED_OUT,
        payload: {
            userHasOptedOut: true
        }
    };
}
